<template>
  <div class="row" id="fixmenu" style="margin:0; padding: 8px 0;">
    <div class="col-12">
      <a :href="'#cat-' + key" v-smooth-scroll="{ duration: 1000, offset: -145 }" class="btn btn-xs btn-buy categories" v-for="(category, key) in categories" :key="category.id">{{
        category.name }}</a>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      categories() {
        return this.$store.state.categories;
      }
    },
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Home/categories.vue